import React, {useState} from 'react'
import { RecoilRoot } from 'recoil'
import GoTop from './GoTop'
import {Link} from 'gatsby'
import Helmet from 'react-helmet'
import CookieConsent from 'react-cookie-consent'
import { isWindows } from 'react-device-detect'
import ReferrerAnalytics from '../../components/Analytics/ReferrerAnalytics'
import Navbar from '../App/Navbar'
import Footer from '../App/Footer'
import HiddenPages from '../../utils/HiddenPages'


const Layout = ({ children, env }) => {

   //ask for pass
   const [isVerified, setIsVerified] = useState(false);
   const [error, setError] = useState(false);
   const [noPass, setNoPass] = useState(false);
   const urlToHide = typeof window !== 'undefined' ? HiddenPages.includes(window.location.pathname) : '';

   const checkPw = (e) => {
       const answer = document.getElementById("password").value;    
       if(answer === "gemai23") { 
           setIsVerified(true);
       } else if(answer !== 'gemai23' && answer !== '') {
           setError(true)
           setNoPass(false)
       } else if(answer === '') {
           setNoPass(true)
       } 
       e.preventDefault()
   };
    
    return (
        <RecoilRoot>
            <CookieConsent
                location="bottom"
                buttonText="Okay, thanks"
                cookieName="bluemailCookie"
                style={{ background: '#2B373B', fontSize: '15px' }}
                buttonStyle={{
                color: 'white',
                background: '#0B71BC',
                fontSize: '13px',
                margin: '0 100px 0 0',
                cursor: 'pointer',
                }}
            >
                This site uses cookies to assist with navigation and your ability to
                provide feedback, analyze your use of our products and services{' '}
                <Link style={{ fontWeight: '600', color: '#1F6BF1' }} to="/cookie-policy/">
                Find out more.
                </Link>
            </CookieConsent>
            <Helmet>
                <link rel="icon" type="image/png" href="/img/mini-logo.webp" />
                {env && env === 'staging' && <meta name="robots" content="noindex" />}
            </Helmet>
              { !urlToHide ? children : isVerified ? children : 
                <div>
                    <Navbar />
                    <div className='container pt-120 pb-120 pass-req'>
                        <form onSubmit= { checkPw } >
                            <div class="form-group mx-sm-3 mb-2">
                                <label for="Password" class="sr-only">Password</label>
                                <input type="password" class="form-control form-control-sm " id="password" name="password" placeholder="Password" />
                            </div>
                            <button type="submit" class="default-btn-white mt-2">Submit</button>
                            {error && !noPass && <div className='error-pass mt-2'>Wrong password! <br /> Please try again.</div>}
                            {noPass && <div className='error-pass mt-2'>Please insert password!</div>}
                        </form>
                    </div>
                    <Footer />
                </div>
            }
            <GoTop scrollStepInPx="100" delayInMs="10.50" />
        </RecoilRoot>
    )
}

export default Layout
